import { render, staticRenderFns } from "./ScheduleSlotForm.vue?vue&type=template&id=28b7ad96&scoped=true&"
import script from "./ScheduleSlotForm.vue?vue&type=script&lang=js&"
export * from "./ScheduleSlotForm.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleSlotForm.vue?vue&type=style&index=0&id=28b7ad96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b7ad96",
  null
  
)

export default component.exports